import { render } from "./visitorRecordItem.vue?vue&type=template&id=cd9fc3a0&scoped=true"
import script from "./visitorRecordItem.vue?vue&type=script&lang=js"
export * from "./visitorRecordItem.vue?vue&type=script&lang=js"

import "./visitorRecordItem.vue?vue&type=style&index=0&id=cd9fc3a0&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9fc3a0"]])

export default __exports__